<div class="ct-wrapper">
  <!-- ══════════════════════════════════════════════════════════════════
           F I L T E R   B A R
      ══════════════════════════════════════════════════════════════════ -->
  <div class="ct-filter-bar">
    <!-- ── Company Multi-Select ─────────────────────────────────────── -->
    <div class="ct-filter-group">
      <label class="ct-filter-label">Company</label>
      <div class="ct-multiselect-host" #companyDropdownHost>
        <button
          type="button"
          class="ct-multiselect-trigger"
          [class.ct-multiselect-trigger--active]="pendingCompanies.length > 0"
          (click)="toggleCompanyDropdown()"
          [attr.aria-expanded]="companyDropdownOpen"
          aria-haspopup="listbox"
        >
          <span class="ct-multiselect-label">
            @if (pendingCompanies.length === 0) {
              All Companies
            } @else if (pendingCompanies.length === 1) {
              {{ pendingCompanies[0] }}
            } @else {
              {{ pendingCompanies.length }} companies selected
            }
          </span>
          <svg
            class="ct-chevron"
            [class.ct-chevron--open]="companyDropdownOpen"
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            aria-hidden="true"
          >
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </button>

        @if (companyDropdownOpen) {
          <div
            class="ct-multiselect-panel"
            role="listbox"
            aria-multiselectable="true"
            aria-label="Select companies"
          >
            <div class="ct-multiselect-search">
              <svg
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#8a96a8"
                stroke-width="2"
                aria-hidden="true"
              >
                <circle cx="11" cy="11" r="8" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>
              <input
                #companySearchInput
                type="text"
                class="ct-multiselect-search-input"
                placeholder="Search companies…"
                [value]="companySearchText()"
                (input)="onCompanySearch($event)"
                aria-label="Search companies"
                autocomplete="off"
              />
              @if (companySearchText()) {
                <button
                  type="button"
                  class="ct-search-clear"
                  (click)="clearCompanySearch()"
                  aria-label="Clear search"
                >
                  ✕
                </button>
              }
            </div>

            <div class="ct-multiselect-actions">
              <button
                type="button"
                class="ct-multiselect-action-btn"
                (click)="selectAllCompanies()"
              >
                Select All
              </button>
              <button
                type="button"
                class="ct-multiselect-action-btn"
                (click)="clearPendingCompanies()"
              >
                Clear
              </button>
            </div>

            <ul class="ct-multiselect-list">
              @if (filteredCompanyOptions().length === 0) {
                <li class="ct-multiselect-empty">No companies found</li>
              }
              @for (co of filteredCompanyOptions(); track co) {
                <li
                  class="ct-multiselect-option"
                  [class.ct-multiselect-option--selected]="
                    isPendingCompanySelected(co)
                  "
                  role="option"
                  [attr.aria-selected]="isPendingCompanySelected(co)"
                  (click)="togglePendingCompany(co)"
                >
                  <span
                    class="ct-checkbox"
                    [class.ct-checkbox--checked]="isPendingCompanySelected(co)"
                    aria-hidden="true"
                  >
                    @if (isPendingCompanySelected(co)) {
                      ✓
                    }
                  </span>
                  {{ co }}
                </li>
              }
            </ul>
          </div>
        }
      </div>
    </div>

    <!-- ── Category Type ─────────────────────────────────────────────── -->
    <div class="ct-filter-group">
      <label class="ct-filter-label" for="ct-category-select"
        >Category Type</label
      >
      <select
        id="ct-category-select"
        class="ct-select"
        [(ngModel)]="pendingCategoryType"
        aria-label="Filter by category type"
      >
        <option value="">All Categories</option>
        @for (cat of categoryTypes(); track cat) {
          <option [value]="cat">{{ cat }}</option>
        }
      </select>
    </div>

    <!-- ── Auto Renewal ──────────────────────────────────────────────── -->
    <!-- <div class="ct-filter-group">
      <label class="ct-filter-label" for="ct-renewal-select"
        >Auto Renewal</label
      >
      <select
        id="ct-renewal-select"
        class="ct-select"
        [(ngModel)]="pendingAutoRenewal"
        aria-label="Filter by auto renewal"
      >
        <option value="">All</option>
        <option value="yes">Yes</option>
        <option value="no">No</option>
      </select>
    </div> -->
    <!-- contract status -->
    <div class="ct-filter-group">
      <label class="ct-filter-label" for="ct-status-select"
        >Contract Status</label
      >
      <select
        id="ct-status-select"
        class="ct-select"
        [(ngModel)]="pendingContractStatus"
      >
        <option value="">All</option>
        <option value="Active">Active</option>
        <option value="Expired">Expired</option>
        <option value="Terminated">Terminated</option>
      </select>
    </div>

    <!-- ── Termination Date Range ────────────────────────────────────── -->
    <div class="ct-filter-group ct-filter-group--date">
      <label class="ct-filter-label">Expiry Date</label>
      <div class="ct-date-range-host">
        <!-- Preset -->
        <select
          class="ct-select ct-select--date-preset"
          [(ngModel)]="pendingExpiryPreset"
          (ngModelChange)="onExpiryPresetChange($event)"
          aria-label="Expiry date preset"
        >
          <option value="all">All</option>
          <option value="">Custom Range</option>
          <option value="-30">Expired in the Past 30 Days</option>
          <option value="30">Expiring in the Next 30 Days</option>

          <option value="-60">Expired in the Past 60 Days</option>
          <option value="60">Expiring in the Next 60 Days</option>
        </select>

        <!-- PrimeNG DatePicker inputs (only shown when preset is empty / Custom Range) -->
        @if (pendingExpiryPreset === "") {
          <div class="ct-date-inputs">
            <div class="ct-date-field">
              <span class="ct-date-field-label">From</span>
              <p-datepicker
                [(ngModel)]="pendingDateFromObj"
                [showIcon]="true"
                [showButtonBar]="true"
                dateFormat="mm/dd/yy"
                placeholder="MM/DD/YYYY"
                [showOnFocus]="true"
                [maxDate]="pendingDateToObj ?? undefined"
                inputId="ct-date-from"
                styleClass="ct-primeng-datepicker"
                inputStyleClass="ct-date-input"
                aria-label="Termination date from"
                appendTo="body"
              />
            </div>
            <span class="ct-date-sep">–</span>
            <div class="ct-date-field">
              <span class="ct-date-field-label">To</span>
              <p-datepicker
                [(ngModel)]="pendingDateToObj"
                [showIcon]="true"
                [showButtonBar]="true"
                dateFormat="mm/dd/yy"
                placeholder="MM/DD/YYYY"
                [showOnFocus]="true"
                [minDate]="pendingDateFromObj ?? undefined"
                inputId="ct-date-to"
                styleClass="ct-primeng-datepicker"
                inputStyleClass="ct-date-input"
                aria-label="Termination date to"
                appendTo="body"
              />
            </div>
          </div>
        }
      </div>
    </div>

    <!-- ── Action buttons ────────────────────────────────────────────── -->
    <div class="ct-filter-actions">
      <button
        type="button"
        class="ct-btn-search"
        (click)="applyFilters()"
        [disabled]="loading()"
        aria-label="Apply filters and search"
      >
        <svg
          width="13"
          height="13"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
        Search
      </button>

      @if (hasAppliedFilters()) {
        <button type="button" class="ct-btn-reset" (click)="resetFilters()">
          Reset
        </button>
      }
    </div>

    <!-- <div class="ct-record-count" aria-live="polite">
          Showing {{ rows().length }} of {{ apiTotal() }} records
        </div> -->
  </div>
  <!-- /filter-bar -->

  <!-- ── Applied Filter Chips ─────────────────────────────────────────── -->
  @if (hasAppliedFilters()) {
    <div class="ct-chips-bar" aria-label="Active filters">
      @if (appliedContractStatus) {
        <span class="ct-chip">
          <span class="ct-chip-label">Status: {{ appliedContractStatus }}</span>
          <button
            type="button"
            class="ct-chip-remove"
            (click)="removeChip('contractStatus')"
            aria-label="Remove contract status filter"
          >
            ✕
          </button>
        </span>
      }
      @if (appliedCompanies.length > 0) {
        <span class="ct-chip">
          <span class="ct-chip-label">
            {{
              appliedCompanies.length === 1
                ? appliedCompanies[0]
                : appliedCompanies.length + " companies"
            }}
          </span>
          <button
            type="button"
            class="ct-chip-remove"
            (click)="removeChip('companies')"
            aria-label="Remove company filter"
          >
            ✕
          </button>
        </span>
      }
      @if (appliedCategoryType) {
        <span class="ct-chip">
          <span class="ct-chip-label">{{ appliedCategoryType }}</span>
          <button
            type="button"
            class="ct-chip-remove"
            (click)="removeChip('category')"
            aria-label="Remove category filter"
          >
            ✕
          </button>
        </span>
      }
      <!-- @if (appliedAutoRenewal !== "") {
        <span class="ct-chip">
          <span class="ct-chip-label"
            >Auto Renewal:
            {{ appliedAutoRenewal === "yes" ? "Yes" : "No" }}</span
          >
          <button
            type="button"
            class="ct-chip-remove"
            (click)="removeChip('autoRenewal')"
            aria-label="Remove auto renewal filter"
          >
            ✕
          </button>
        </span>
      } -->
      @if (appliedExpiryPreset || appliedDateFrom || appliedDateTo) {
        <span class="ct-chip">
          <span class="ct-chip-label">{{ expiryChipLabel() }}</span>
          <button
            type="button"
            class="ct-chip-remove"
            (click)="removeChip('expiry')"
            aria-label="Remove termination date filter"
          >
            ✕
          </button>
        </span>
      }
    </div>
  }

  <!-- ── Loading ─────────────────────────────────────────────────────── -->
  @if (loading()) {
    <div class="ct-state-panel" role="status">
      <svg
        class="ct-spinner"
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#1976d2"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <path d="M21 12a9 9 0 1 1-6.219-8.56" />
      </svg>
      <span>Loading contracts…</span>
    </div>
  }

  <!-- ── Error ───────────────────────────────────────────────────────── -->
  @if (!loading() && error()) {
    <div class="ct-state-panel ct-state-panel--error" role="alert">
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <circle cx="12" cy="16" r="0.5" fill="currentColor" />
      </svg>
      <span>{{ error() }}</span>
    </div>
  }

  <!-- ── Table ───────────────────────────────────────────────────────── -->
  @if (!loading() && !error()) {
    <div
      class="ct-table-container"
      role="region"
      aria-label="Contracts table"
      tabindex="0"
    >
      <table class="ct-table">
        <caption class="ct-visually-hidden">
          Contract documents list
        </caption>

        <thead>
          <tr class="ct-thead-row">
            <th
              class="ct-th ct-th--sortable ct-col-contract"
              scope="col"
              (click)="sort('contractName')"
              [attr.aria-sort]="ariaSort('contractName')"
            >
              Contract Name
              <span class="ct-sort-icon">{{ sortIcon("contractName") }}</span>
            </th>
            <!-- <th
              class="ct-th ct-th--sortable ct-col-company"
              scope="col"
              (click)="sort('companyName')"
              [attr.aria-sort]="ariaSort('companyName')"
            >
              Company Name
              <span class="ct-sort-icon">{{ sortIcon("companyName") }}</span>
            </th> -->
            <th
              class="ct-th ct-th--sortable ct-col-category"
              scope="col"
              (click)="sort('categoryType')"
              [attr.aria-sort]="ariaSort('categoryType')"
            >
              Category Type
              <span class="ct-sort-icon">{{ sortIcon("categoryType") }}</span>
            </th>
            <th
              class="ct-th ct-th--sortable ct-col-date"
              scope="col"
              (click)="sort('effectiveDate')"
              [attr.aria-sort]="ariaSort('effectiveDate')"
            >
              Effective Date
              <span class="ct-sort-icon">{{ sortIcon("effectiveDate") }}</span>
            </th>
            <th
              class="ct-th ct-th--sortable ct-col-date"
              scope="col"
              (click)="sort('expiryDate')"
              [attr.aria-sort]="ariaSort('expiryDate')"
            >
              Expiry Date
              <span class="ct-sort-icon">{{ sortIcon("expiryDate") }}</span>
            </th>
            <th
              class="ct-th ct-th--sortable ct-col-date"
              scope="col"
              (click)="sort('terminationDate')"
              [attr.aria-sort]="ariaSort('terminationDate')"
            >
              Termination Date
              <span class="ct-sort-icon">{{
                sortIcon("terminationDate")
              }}</span>
            </th>
            <th
              class="ct-th ct-th--sortable ct-col-date"
              scope="col"
              (click)="sort('renewalDate')"
              [attr.aria-sort]="ariaSort('renewalDate')"
            >
              Renewal Date
              <span class="ct-sort-icon">{{ sortIcon("renewalDate") }}</span>
            </th>
            <th class="ct-th ct-col-summary" scope="col">
              Termination Summary
            </th>
            <!-- <th
              class="ct-th ct-th--sortable ct-col-renewal ct-th--center"
              scope="col"
              (click)="sort('isExpired')"
              [attr.aria-sort]="ariaSort('isExpired')"
            >
              Auto Renewal
              <span class="ct-sort-icon">{{ sortIcon("isExpired") }}</span>
            </th>
            <th class="ct-th ct-col-renewal-summary" scope="col">
              Auto Renewal Summary
            </th> -->
            <th class="ct-th ct-col-comments" scope="col">Comments</th>
            <th
              class="ct-th ct-th--sortable ct-col-status ct-th--center"
              scope="col"
              (click)="sort('isExpired')"
              [attr.aria-sort]="ariaSort('isExpired')"
            >
              Contract Status
              <span class="ct-sort-icon">{{ sortIcon("isExpired") }}</span>
            </th>
            <th class="ct-th ct-col-actions ct-th--center" scope="col">
              Actions
            </th>
          </tr>
        </thead>

        <tbody>
          @if (groupedRows().length === 0) {
            <tr>
              <td colspan="10" class="ct-empty-cell">
                <div class="ct-empty-state">
                  <!-- ...existing empty state SVG... -->
                  <span>No records found</span>
                </div>
              </td>
            </tr>
          }

          @for (group of groupedRows(); track group.companyName) {
            <!-- Group header row -->
            <!-- <tr class="ct-group-header-row" (click)="toggleGroup(group.companyName)">
      <td colspan="10" class="ct-group-header-cell">
        <span class="ct-group-chevron" [class.ct-group-chevron--open]="group.expanded">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2.5" aria-hidden="true">
            <polyline points="6 9 12 15 18 9"/>
          </svg>
        </span>
        <span class="ct-group-company-name">{{ group.companyName }}</span>
        <span class="ct-group-count">{{ group.rows.length }} contract{{ group.rows.length !== 1 ? 's' : '' }}</span>
      </td>
    </tr> -->
            <!-- Group header row — colspan must equal exact number of <th> columns -->
            <tr
              class="ct-group-header-row"
              (click)="toggleGroup(group.companyName)"
            >
              <td colspan="10" class="ct-group-header-cell">
                <span
                  class="ct-group-chevron"
                  [class.ct-group-chevron--open]="group.expanded"
                >
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.5"
                    aria-hidden="true"
                  >
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </span>
                <span class="ct-group-company-name">{{
                  group.companyName
                }}</span>
                <span class="ct-group-count"
                  >{{ group.rows.length }} contract{{
                    group.rows.length !== 1 ? "s" : ""
                  }}</span
                >
              </td>
            </tr>

            <!-- Contract rows (only shown when expanded) -->
            @if (group.expanded) {
              @for (row of group.rows; track row.id) {
                <tr class="ct-row" [class.ct-row--expired]="row.isExpired">
                  <td class="ct-td ct-col-contract">
                    <span class="ct-contract-name" [title]="row.contractName">
                      {{ truncate(row.contractName, 60) }}
                    </span>
                  </td>
                  <!-- REMOVE the company <td> entirely -->
                  <td class="ct-td ct-col-category" [title]="row.categoryType">
                    <span class="ct-category-text">{{
                      row.categoryType || "-"
                    }}</span>
                  </td>
                  <td class="ct-td ct-col-date ct-date-text">
                    {{ formatDate(row.effectiveDate) }}
                  </td>
                  <td class="ct-td ct-col-date ct-date-text">
                    {{ formatDate(row.expiryDate) }}
                  </td>
                  <td class="ct-td ct-col-date ct-date-text">
                    {{ formatDate(row.terminationDate) }}
                  </td>
                  <td class="ct-td ct-col-date ct-date-text">
                    {{ formatDate(row.renewalDate) }}
                  </td>
                  <td class="ct-td ct-col-summary">
                    <span
                      class="ct-summary-text"
                      [title]="row.terminationSummary"
                    >
                      {{ truncate(row.terminationSummary, 100) }}
                    </span>
                  </td>
                  <!-- REMOVE auto renewal <td> and auto renewal summary <td> -->
                  <td class="ct-td ct-col-comments">
                    <span class="ct-summary-text" [title]="row.comments">
                      {{ truncate(row.comments, 80) }}
                    </span>
                  </td>
                  <td class="ct-td ct-col-status ct-td--center">
                    <span
                      class="ct-badge"
                      [class.ct-badge--active]="
                        row.contract_status === 'Active'
                      "
                      [class.ct-badge--expired]="
                        row.contract_status === 'Expired'
                      "
                      [class.ct-badge--terminated]="
                        row.contract_status === 'Terminated'
                      "
                    >
                      {{ row.contract_status ?? "-" }}
                    </span>
                  </td>
                  <td class="ct-td ct-col-actions">
                    <div class="ct-actions-cell">
                      <!-- ✅ REPLACE the empty edit button with this: -->
                      <button
                        type="button"
                        class="ct-action-btn"
                        [attr.aria-label]="'Edit contract: ' + row.contractName"
                        (click)="openEdit(row)"
                      >
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <path
                            d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
                          />
                          <path
                            d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
                          />
                        </svg>
                      </button>

                      <!-- ✅ REPLACE the empty view button with this: -->
                      <button
                        type="button"
                        class="ct-action-btn"
                        [attr.aria-label]="'View contract: ' + row.contractName"
                        (click)="openPreview(row)"
                      >
                        <svg
                          width="15"
                          height="15"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <path
                            d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                          />
                          <circle cx="12" cy="12" r="3" />
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
              }
            }
          }
        </tbody>
      </table>
    </div>

    <!-- ── Pagination ─────────────────────────────────────────────────── -->
    <div class="ct-pagination-bar">
      <div class="ct-record-count" aria-live="polite">
        Showing {{ rows().length }} of {{ apiTotal() }} records
      </div>
      <div class="ct-page-size-host">
        <span class="ct-page-size-label" id="pageSizeLabel"
          >Rows per page:</span
        >
        <select
          class="ct-select ct-select--sm"
          [(ngModel)]="pageSizeValue"
          (ngModelChange)="onPageSizeChange($event)"
          aria-labelledby="pageSizeLabel"
        >
          <!-- <option [value]="10">10</option> -->
          <option [value]="25">25</option>
          <option [value]="50">50</option>
          <option [value]="75">75</option>
          <option [value]="100">100</option>
        </select>
      </div>

      <nav class="ct-pager" aria-label="Table pagination">
        <span class="ct-page-info"
          >Page {{ currentPage() }} of {{ totalPages() }}</span
        >
        <button
          class="ct-pager-btn"
          type="button"
          [disabled]="currentPage() === 1"
          (click)="goToPage(1)"
          aria-label="Go to first page"
        >
          Previous
        </button>
        <button
          class="ct-pager-btn"
          type="button"
          [disabled]="currentPage() === 1"
          (click)="goToPage(currentPage() - 1)"
          aria-label="Go to previous page"
        >
          ‹
        </button>
        @for (p of visiblePages(); track $index) {
          <button
            [class]="getPagerBtnClass(p)"
            type="button"
            [disabled]="p === -1"
            [attr.aria-current]="p === currentPage() ? 'page' : null"
            (click)="p !== -1 && goToPage(p)"
          >
            {{ p === -1 ? "…" : p }}
          </button>
        }
        <button
          class="ct-pager-btn"
          type="button"
          [disabled]="currentPage() === totalPages()"
          (click)="goToPage(currentPage() + 1)"
          aria-label="Go to next page"
        >
          ›
        </button>
        <button
          class="ct-pager-btn"
          type="button"
          [disabled]="currentPage() === totalPages()"
          (click)="goToPage(totalPages())"
          aria-label="Go to last page"
        >
          Next
        </button>
      </nav>
    </div>
  }
</div>
<!-- /ct-wrapper -->

<!-- ══════════════════════════════════════════════════════════════════════
         P R E V I E W   M O D A L
    ══════════════════════════════════════════════════════════════════════ -->
@if (previewRow) {
  <!-- Backdrop -->
  <div
    class="ct-modal-backdrop"
    role="presentation"
    (click)="closePreview()"
  ></div>

  <!-- Dialog -->
  <div
    class="ct-modal-dialog"
    [class.ct-modal-dialog--fullscreen]="modalFullscreen"
    role="dialog"
    aria-modal="true"
    [attr.aria-labelledby]="'ct-modal-title'"
  >
    <!-- Header -->
    <div class="ct-modal-header">
      <h4 class="ct-modal-title" id="ct-modal-title">Summary</h4>
      <div class="ct-modal-header-actions">
        <button
          type="button"
          class="ct-modal-icon-btn"
          [attr.aria-label]="
            modalFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'
          "
          (click)="modalFullscreen = !modalFullscreen"
        >
          @if (modalFullscreen) {
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <polyline points="4 14 10 14 10 20" />
              <polyline points="20 10 14 10 14 4" />
              <line x1="10" y1="14" x2="3" y2="21" />
              <line x1="21" y1="3" x2="14" y2="10" />
            </svg>
          } @else {
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <polyline points="15 3 21 3 21 9" />
              <polyline points="9 21 3 21 3 15" />
              <line x1="21" y1="3" x2="14" y2="10" />
              <line x1="3" y1="21" x2="10" y2="14" />
            </svg>
          }
        </button>
        <button
          type="button"
          class="ct-modal-icon-btn ct-modal-icon-btn--close"
          aria-label="Close summary"
          (click)="closePreview()"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
    </div>

    <!-- Contract sub-header -->
    <div class="ct-modal-subheader">
      <span class="ct-modal-contract-name" [title]="previewRow.contractName">
        {{ previewRow.contractName }}
      </span>
      <span
        class="ct-badge"
        [class.ct-badge--expired]="previewRow.isExpired"
        [class.ct-badge--active]="!previewRow.isExpired"
      >
        {{ previewRow.isExpired ? "Expired" : "Active" }}
      </span>
      @if (previewRow.categoryType) {
        <span class="ct-tag">{{ previewRow.categoryType }}</span>
      }
      @if (previewRow.isAutoRenewal !== null) {
        <span
          class="ct-renewal-badge"
          [class.ct-renewal-badge--yes]="previewRow.isAutoRenewal === true"
          [class.ct-renewal-badge--no]="previewRow.isAutoRenewal === false"
        >
          Auto Renewal: {{ formatAutoRenewal(previewRow.isAutoRenewal) }}
        </span>
      }
    </div>

    <!-- Tabs -->
    <div class="ct-modal-tabs" role="tablist" aria-label="Summary sections">
      @for (tab of previewTabs; track tab.key) {
        <button
          class="ct-modal-tab"
          [class.ct-modal-tab--active]="activeTab === tab.key"
          role="tab"
          type="button"
          [attr.aria-selected]="activeTab === tab.key"
          [attr.aria-controls]="'ct-tabpanel-' + tab.key"
          (click)="activeTab = tab.key"
        >
          {{ tab.label }}
        </button>
      }
    </div>

    <!-- Body -->
    <div class="ct-modal-body">
      @for (tab of previewTabs; track tab.key) {
        @if (activeTab === tab.key) {
          <div
            [id]="'ct-tabpanel-' + tab.key"
            class="ct-modal-tab-panel"
            role="tabpanel"
          >
            @if (previewRow.metadata[tab.key]) {
              <div
                class="ct-modal-content"
                [innerHTML]="previewRow.metadata[tab.key]"
              ></div>
            } @else {
              <div class="ct-modal-empty">
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#c8d0dc"
                  stroke-width="1.5"
                  aria-hidden="true"
                >
                  <path
                    d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                  />
                  <polyline points="14 2 14 8 20 8" />
                </svg>
                <span>No content available for this section.</span>
              </div>
            }
          </div>
        }
      }
    </div>
  </div>
}

<!-- edit modal -->
@if (editRow) {
  <div class="ct-modal-backdrop" (click)="closeEdit()"></div>
  <div
    class="ct-modal-dialog"
    style="width: min(480px, 94vw)"
    role="dialog"
    aria-modal="true"
  >
    <div class="ct-modal-header">
      <h4 class="ct-modal-title">Edit Contract</h4>
      <button
        type="button"
        class="ct-modal-icon-btn ct-modal-icon-btn--close"
        (click)="closeEdit()"
      >
        ✕
      </button>
    </div>
    <div class="ct-modal-body" style="padding: 20px">
      <div class="ct-edit-field">
        <label class="ct-filter-label">Expiry Date</label>
        <p-datepicker
          [(ngModel)]="editForm.expiryDate"
          [showIcon]="true"
          [showButtonBar]="true"
          dateFormat="mm/dd/yy"
          placeholder="MM/DD/YYYY"
          styleClass="ct-primeng-datepicker"
          appendTo="body"
        />
      </div>
      <!-- Termination Date -->
      <div class="ct-edit-field">
        <label class="ct-filter-label">Termination Date</label>
        <p-datepicker
          [(ngModel)]="editForm.terminationDate"
          [showIcon]="true"
          [showButtonBar]="true"
          dateFormat="mm/dd/yy"
          placeholder="MM/DD/YYYY"
          styleClass="ct-primeng-datepicker"
          appendTo="body"
        />
      </div>

      <div class="ct-edit-field">
        <label class="ct-filter-label">Termination Summary</label>
        <textarea
          class="ct-textarea"
          [(ngModel)]="editForm.terminationSummary"
          rows="3"
          placeholder="Enter termination summary…"
        ></textarea>
      </div>

      <!-- Auto Renewal -->
      <!-- <div class="ct-edit-field">
        <label class="ct-filter-label">Auto Renewal</label>
        <select class="ct-select" [(ngModel)]="editForm.isAutoRenewal">
          <option value="">Select</option>
          <option value="yes">Yes</option>
          <option value="no">No</option>
        </select>
      </div> -->

      <!-- <div class="ct-edit-field">
        <label class="ct-filter-label">Auto Renewal Summary</label>
        <textarea class="ct-textarea" [(ngModel)]="editForm.autoRenewalSummary" rows="3"
          placeholder="Enter auto renewal summary…"></textarea>
      </div> -->

      <!-- Renewal Date (mandatory if auto renewal = yes) -->
      <div class="ct-edit-field">
        <label class="ct-filter-label">
          Renewal Date
          <!-- @if (editForm.isAutoRenewal === "yes") {
            <span style="color: #c62828">*</span>
          } -->
        </label>
        <p-datepicker
          [(ngModel)]="editForm.renewalDate"
          [showIcon]="true"
          [showButtonBar]="true"
          dateFormat="mm/dd/yy"
          placeholder="MM/DD/YYYY"
          styleClass="ct-primeng-datepicker"
          appendTo="body"
        />
        <!-- @if (editForm.isAutoRenewal === "yes" && !editForm.renewalDate) {
          <span class="ct-edit-error"
            >Renewal date is required when auto renewal is Yes</span
          >
        } -->
      </div>

      <!-- Comments -->
      <div class="ct-edit-field">
        <label class="ct-filter-label">Comments</label>
        <textarea
          class="ct-textarea"
          [(ngModel)]="editForm.comments"
          rows="3"
          placeholder="Enter comments…"
        ></textarea>
      </div>
    </div>
    <div class="ct-modal-footer">
      <button type="button" class="ct-btn-reset" (click)="closeEdit()">
        Cancel
      </button>
      <button
        type="button"
        class="ct-btn-search"
        [disabled]="!isEditFormValid() || editSaving"
        (click)="saveEdit()"
      >
        {{ editSaving ? "Saving…" : "Save" }}
      </button>
    </div>
  </div>
}
